import {GeocoderInput} from "../../components/geocoder/react-geocoder";
import MapControls from "../../components/map-controls";
import BasemapControl from "../../components/basemap-control";
import * as React from "react";
import {IMapState} from "../../store/types";
import {Feature, Geometry} from "geojson";
import {getEmptyData} from "../../utils/emptyData";
import {BasemapImage} from "./basemapImage";

interface IProps {
    mapStyle: IMapState['mapStyle']
    setSinglePoint: (feature?: any) => void
    onViewportChange: (viewport: any) => void
    zoomIn: () => void
    zoomOut: () => void
    resetViewport: () => void
    switchBasemap: () => void
    locateUser: () => void
    userLocation: any
    styleName: string
}

export function RightControls (props: IProps) {
    const {mapStyle,
        setSinglePoint,
        onViewportChange,
        switchBasemap,
        zoomIn,
        zoomOut,
        locateUser,
        userLocation,
        resetViewport,
        styleName
    } = props;

    const setGeocodeResult = React.useCallback((coordinates) => {
        const fc = getEmptyData();
        const geometry: Geometry = {
            coordinates,
            type: 'Point'
        };
        const [longitude, latitude] = geometry.coordinates;
        const feature: Feature = {
            type: 'Feature',
            geometry,
            properties: {}
        };
        fc.data.features.push(feature);
        setSinglePoint(fc);
        onViewportChange({longitude, latitude});
    }, [setSinglePoint, onViewportChange]);

    const unsetGeocodeResult = React.useCallback(() => {
        setSinglePoint();
    },[setSinglePoint]);

    if (!mapStyle) return null;

    return (
        <div className="mapboxgl-ctrl-top-right">
            <div className={'mapboxgl-ctrl'}>
                <GeocoderInput
                    onSelectAddress={setGeocodeResult}
                    onClearAddress={unsetGeocodeResult}
                />
            </div>

            <MapControls className='navControl'
                         onZoomIn={zoomIn}
                         onZoomOut={zoomOut}
                         onLocateUser={locateUser}
                         onViewReset={resetViewport}
                         isLocatingUser={!!userLocation}
            />

            <BasemapControl onBasemapSwitch={switchBasemap}
                            children={
                                <BasemapImage styleName={styleName}/>
                            }
                            label={styleName} className='mapbox-customControl baseMapCtrl'/>
        </div>
    )
}